<template>
  <v-flex>
    <!-- <NotesHeader /> -->
    <!-- height: ${mainHeaderHeight}px; -->
    <div class="mainHeader" :style="`margin-top: ${searchNotesVisible || datePickerVisible ? -10 : ''}`">
      <v-slide-y-transition>
        <div
          class="allNotesCard-head__datePicker"
          :style="`width: ${datePickerWidth}px;`"
          v-show="datePickerVisible"
        >
          <v-date-picker locale="ru" full-width landscape v-model="datePicker" />
          <loading v-if="calendarLoading" />
        </div>
      </v-slide-y-transition>
      <v-slide-y-transition>
        <div v-if="searchNotesVisible" class="notesSearchBlock" :style="`width: ${searchBlockWidth}px;`">
          <v-autocomplete
            color="white"
            ref="searchNotes"
            v-model="searchModel"
            background-color="white"
            :search-input.sync="search"
            :rules="[() => !!searchModel || 'Вы не заполнили поле']"
            :items="notesForSearch"
            label="Введите текст для поиска"
            :hide-selected="false"
            no-data-text="Заметок не найдено"
            solo
            hide-details            
          >
            <template v-slot:append-outer>
              <v-flex shrink>
                <v-expand-transition>
                  <v-chip v-if="isSearchNotes">{{ notesForSearch.length }}</v-chip>
                </v-expand-transition>
              </v-flex>
            </template>
            <template v-slot:item="data" @click.stop="">
              <v-flex class="notesSearchBlock__results-item" @click.stop="goToSearchedNote(data.item.date)">
                <div class="notesSearchBlock__results-item__text">{{data.item.text}}</div>
                <div>{{ data.item.date }}</div>
              </v-flex>
            </template>
          </v-autocomplete>
        </div>
      </v-slide-y-transition>
    </div>
    <v-card class="allNotesCard" id="notesList">
      <Notes />
    </v-card>
  </v-flex>
</template>
<script>
import { debounce } from 'lodash';
import Notes from './Notes';
// import NotesHeader from './NotesHeader';

export default {
  name: 'NotesContainer',
  props: {
    notes: {
      type: Array
      //required: true
    }
  },
  data() {
    return {
      datePicker: null,
      datePickerVisible: false,
      datePickerWidth: null,
      datePickerModeFixed: false,
      searchBlockWidth: null,
      calendarLoading: false,
      searchModel: null,
      notesForSearch: [],
      search: null,
      isLoading: false,
      model: null,

      allNotes: [],
      allNotesLength: 0,
      searchNotesVisible: false
    };
  },
  components: {
    Notes,
    // NotesHeader
  },
  methods: {
    startedScroll() {
      let _notesList = document.getElementById('notesList');
      _notesList.scrollTo(0, 900);
    },
    scrollInit: debounce(function(target){
      // Ищем самый близкий к верху элемент
      let _currentNotes = document.getElementsByClassName('allNotesCard__container-item')
      for(let item of _currentNotes) {
        if(item.getBoundingClientRect().top >= 100 && item.getBoundingClientRect().top <= 150 ) {
          this.$bus.$emit('inViewCurrentNote',item.id)
        }
      }
    },0),
    
    goToSearchedNote(date) {
      let _target = document.getElementById(date)
      this.notesForSearch.map(note=>{
        if(note.date === date && _target) { // Если есть в нашем массиве
          _target.scrollIntoView({block: 'start'})
        } else {
          this.$bus.$emit('goToSearchedNote', date)
          this.$bus.$emit('showOnCalendar', date )
        }
      })
    }
  },
  computed: {
    isSearchNotes() {
      return this.notesForSearch.length > 0
    },
    mainHeaderHeight() {
      let _searchResultsItemHeight = 64
      // if(this.datePickerVisible) return 215    
      if(this.searchNotesVisible) {
        if(this.notesForSearch.length > 6) {
          // return 300 + 88
          // return 360
        } else if(this.notesForSearch.length < 6) {
          return this.notesForSearch.length * _searchResultsItemHeight 
        } else {
          // return 88
        }
      }
      else return 0
    }
  },
  watch: {
    // Функция при выборе даты на календаре
    datePicker: function(date) {
      this.$bus.$emit('datePickerInit', date);
      this.calendarLoading = true
      setTimeout(()=>{
        this.calendarLoading = false
      },1000)
    },
    search: debounce(function(val) {
      this.notesForSearch = []
      if(!val || val.length === 0) {
        this.notesForSearch = []
        return
      }
      store.dispatch('SEARCH_NOTES', val).then((res)=>{
        let _results = store.getters['GET_SEARCH_NOTES'].results
        _results.map((note)=>{
          this.notesForSearch.push({
            text: note.text.replace(/<[^>]*>?/gm, '').replace(/&nbsp/gm, ''),
            date: note.date
          })
        })
        this.notesForSearch.sort((a, b)=>{
          if(a.date > b.date) {
            return -1
          }else if(a.date > b.date) {
            return 1
          } else {
            return 0
          }
        })       
      })
    },400)    
  },
  mounted() {
    this.$bus.$on('clientNotesChanged', notes => {
      this.allNotesLength = notes;
    });
    this.$bus.$on('datePickerVisible', status => {
      this.datePickerWidth = document.getElementById('notesList').offsetWidth; // По ширине родителя
      if(status && this.searchNotesVisible) {
        this.searchNotesVisible = false
      }
      // this.datePickerWidth = 440;
      this.datePickerVisible = status;
      this.$bus.$emit('hideSearchBlock')
    });
    this.$bus.$on('searchInit',(status) => {
      this.searchModel = null
      if(status && this.datePickerVisible) {
        this.datePickerVisible = false
      }
      this.searchNotesVisible = status
      this.searchBlockWidth = document.getElementById('notesList').offsetWidth; // По ширине родителя
      this.$bus.$emit('hideDatePicker')
      
    })
    let _notesList = document.getElementById('notesList');
    _notesList.addEventListener('scroll', e => {
      this.scrollInit(e.currentTarget);
    });  
    // Задаем ширину выпадающего списка 
    // let _autoCompleteResultsWidth = document.getElementsByClassName('searchBlock')[0].childNodes[0].children[0].offsetWidth // Ширина 
    // let _target = document.getElementsByClassName('v-select-list')[0]
    // _target.style.width = _autoCompleteResultsWidth + 'px';
    // debugger
    // let _out = _autoCompleteResults[]
    // console.log('autoComplete ', _autoCompleteResults)
    
  },
  destroyed() {
    // _notesList.removeEventListener('scroll');
    this.$bus.$off('renderReadyScroll');
    this.$bus.$off('clientNotesChanged');
    this.$bus.$off('datePickerVisible');
    this.$bus.$off('searchInit')
  }
};
</script>
<style lang='scss'>



</style>



// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/NotesContainer.vue